import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const PasswordUpdateForm = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [mobileOnly, setMobileOnly] = useState(false);
    const [done, setDone] = useState(false);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    // Mobile-only accounts cannot sign in here, so they are sent to a confirmation
    // rather than the login form. A failed lookup leaves the normal flow untouched.
    useEffect(() => {
        if (!token) return;
        fetch(`${apiUrl}/password-reset/validate/${token}`)
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => setMobileOnly(data?.web_access === false))
            .catch(() => setMobileOnly(false));
    }, [token, apiUrl]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (newPassword !== repeatPassword) {
            setError("Passwords do not match.");
            return;
        }

        setError(""); // Clear any existing errors

        try {
            console.log("Token being sent:", token);
            const response = await fetch(`${apiUrl}/password-reset/update`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, new_password: newPassword }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.detail || "Failed to update password.");
            setMessage("Password updated successfully.");
            setDone(true);
            if (!mobileOnly) {
                setTimeout(() => navigate("/login"), 2000); // Redirect to login after 2 seconds
            }
        } catch (error) {
            setError(error.message || "Error updating password.");
        }
    };

    if (done && mobileOnly) {
        return (
            <div className="">
                <div className="login100-form validate-form">
                    <span className="login100-form-title p-b-26">
                        <img align="center" alt="Kai" src="/libraries/assets/images/new_logo.png"/><br/>
                        Password Set
                    </span>
                    <p className="text-success" style={{textAlign: "center"}}>
                        Your password has been set.
                    </p>
                    <p style={{textAlign: "center"}}>
                        This account is set up for the Kai mobile app. Open the app on your
                        device and sign in with your email and new password.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="">

            <form className="login100-form validate-form" onSubmit={handleUpdate}>

                <span className="login100-form-title p-b-26">
                    <img align="center" src="/libraries/assets/images/new_logo.png"/><br/>
						Setup Password
					</span>
                <div className="wrap-input100 validate-input">
                <input
                        className="input100"
                        type="password"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="wrap-input100 validate-input">

                    <input
                        className="input100"
                        type="password"
                        placeholder="Repeat new password"
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <p className="text-danger">{error}</p>}
                <div className="container-login100-form-btn">
                    <div className="wrap-login100-form-btn">
                        <div className="login100-form-bgbtn"></div>
                        <button type="submit" className="login100-form-btn">Update Password</button>
                    </div>
                </div>
                        {message && <p className="text-success">{message}</p>}
            </form>
        </div>
);
};

export default PasswordUpdateForm;